/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport } from '@typescript-kit/core';
import { Locale } from '@typescript-kit/core';

import * as texts from '../text/view-en.text.json';

export const viewEnLocale: Locale = {
  texts: getJsonExport(texts)
};
